webpackJsonp([27],{

/***/ 1047:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_assets_js_re_print_list_js__ = __webpack_require__(1062);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_228659f4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sale_bill_vue__ = __webpack_require__(1399);
var normalizeComponent = __webpack_require__(494)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_assets_js_re_print_list_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_228659f4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sale_bill_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1062:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service_pos__ = __webpack_require__(498);


// import Swal from 'sweetalert2'

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      bill_data: [],
      hostshift: '',
      search: '',
      currentPage: 1,
      items_perpage: 10,
      header: {
        headers: {
          'Access-Token': sessionStorage.token
        }
      },
      form_data: ''
    };
  },
  created: function created() {
    this.checkUser();
    // if (sessionStorage.hostshift) {
    //   this.hostshift = JSON.parse(sessionStorage.hostshift)
    // } else {
    //   this.$router.push('/')
    // }
  },

  computed: {
    paginate: function paginate() {
      this.totalItem = this.bill_data.length;
      if (this.currentPage >= this.totalPages) {
        this.currentPage = Math.max(0, this.totalPages - 1);
      }
      var index = (this.currentPage - 1) * this.items_perpage;
      return this.bill_data.slice(index, index + this.items_perpage);
    }
  },
  methods: {
    searchDetail: function searchDetail() {
      clearTimeout(this.timeout);
      var self = this;
      this.timeout = setTimeout(function () {
        // enter this block of code after 1 second
        // handle stuff, call search API etc.
        console.log(this.timeout);
        self.getBillAll();
      }, 400);
    },
    CheckSearch: function CheckSearch() {
      if (this.search === '') {
        this.onChange(1);
        this.getBillAll();
      }
    },
    itemRender: function itemRender(current, type, originalElement) {
      if (type === 'prev') {
        return 'Previous';
      } else if (type === 'next') {
        return 'Next';
      }
      return originalElement;
    },
    onChange: function onChange(pageNumber) {
      this.currentPage = pageNumber;
    },
    getBillAll: function getBillAll() {
      var _this = this;

      // this.$store.commit('Loading')
      var obj = {
        'host_code': '01',
        'keyword': this.search
      };
      __WEBPACK_IMPORTED_MODULE_1__services_service_pos__["a" /* default */].billPosList(this.REST_URL, obj, this.header, function (result) {
        if (result.response === 'success') {
          _this.bill_data = [];
          result.data.forEach(function (val) {
            if (val['holding_status'] === 0 && val['is_cancel'] === 0) {
              _this.bill_data.push(val);
            }
          });
        } else {
          _this.$notification['warning']({
            message: 'เปิดการขายไม่ได้',
            description: result.message
          });
        }
        // this.$store.commit('Loading')
      }, function (error) {
        alert('ไม่สามารถเข้าถึงข้อมูล ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        // this.$store.commit('Loading')
      });
    },

    // cancelBill (data) {
    //   $('#ToolModal').modal('hide')
    //   Swal.fire({
    //     title: 'ยกเลิกบิล',
    //     text: 'ท่านต้องการยกเลิกบิลขายเลขที่ ' + data.doc_no + ' ใช่หรือไม่ ?',
    //     icon: 'warning',
    //     showCancelButton: true,
    //     confirmButtonColor: '#3085d6',
    //     cancelButtonColor: '#d33',
    //     confirmButtonText: 'ตกลง',
    //     cancelButtonText: 'ปิด'
    //   }).then((res) => {
    //     if (res.value) {
    //       this.$store.commit('Loading')
    //       var obj = {
    //         'doc_no': data.doc_no
    //       }
    //       api.cancelBill(this.REST_URL,
    //         obj,
    //         this.header,
    //         result => {
    //           if (result.response === 'success') {
    //             this.$notification['success']({
    //               message: 'ยกเลิกบิล',
    //               description: 'ยกเลิกบิลเรียบร้อย'
    //             })
    //             this.search = ''
    //           } else {
    //             this.$notification['warning']({
    //               message: 'ยกเลิกบิล',
    //               description: 'ยกเลิกบิลไม่สมบูรณ์'
    //             })
    //           }
    //           this.$store.commit('Loading')
    //         },
    //         error => {
    //           alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
    //         }
    //       )
    //     } else {
    //       $('#ToolModal').modal('show')
    //     }
    //   })
    // },
    // printBill (docNo) {
    //   this.$store.commit('Loading')
    //   var obj = {
    //     'printer_port': this.hostshift.printer_port,
    //     'doc_no': docNo
    //   }
    //   api.printBill(this.REST_URL,
    //     obj,
    //     this.header,
    //     result => {
    //       if (result.response === 'success') {
    //         this.$notification['success']({
    //           message: 'พิมพ์ใบเสร็จสำเร็จ',
    //           description: result.message
    //         })

    //         this.$store.commit('Loading')
    //       } else {
    //         this.$notification['warning']({
    //           message: 'พิมพ์ใบเสร็จไม่ได้',
    //           description: result.message
    //         })
    //         this.$store.commit('Loading')
    //       }
    //     },
    //     error => {
    //       alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
    //       this.$store.commit('Loading')
    //     }
    //   )
    // },
    printPDF: function printPDF(obj) {
      var _this2 = this;

      this.$store.commit('Loading');
      __WEBPACK_IMPORTED_MODULE_1__services_service_pos__["a" /* default */].billCreditDetail(this.REST_URL, this.header, { doc_no: obj.doc_no }, function (result) {
        if (result.response === 'success') {
          _this2.form_data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(result.data);
          setTimeout(function () {
            _this2.$refs.printHolding.submit();
            _this2.$store.commit('Loading');
          }, 1000);
        } else {
          _this2.$notification['warning']({
            message: 'พิมพ์ใบแจ้งยอดไม่ได้',
            description: result.message
          });
          _this2.$store.commit('Loading');
        }
      }, function (error) {
        _this2.$store.commit('Loading');
        alert('ไม่สามารถเข้าถึงข้อมูล ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
      });
    },
    openDetailBill: function openDetailBill(val) {
      console.log(val);
      this.$store.state.detail_pop = val;
      $('#itemDetailBill').modal('show');
    }
  },
  mounted: function mounted() {
    this.search = '';
    this.getBillAll();
  }
});

/***/ }),

/***/ 1399:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card mt-3"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body p-2",staticStyle:{"font-size":"18px"}},[_c('div',{staticClass:"row"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-sm"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"กรอกคำค้น...."},domProps:{"value":(_vm.search)},on:{"keyup":[_vm.CheckSearch,function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.onChange(1); _vm.getBillAll();}],"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-3 text-left"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.onChange(1); _vm.getBillAll();}}},[_c('i',{staticClass:"fas fa-search"}),_vm._v(" ค้นหา\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-sm"},[_vm._m(2),_vm._v(" "),_c('tbody',[_vm._l((_vm.paginate),function(b,i){return _c('tr',{key:'bill' + i},[_c('th',{staticClass:"text-center pb-0",attrs:{"scope":"row"}},[_vm._v("\n              "+_vm._s(_vm.items_perpage * _vm.currentPage - (_vm.items_perpage - i) + 1)+"\n            ")]),_vm._v(" "),_c('td',{staticClass:"text-center pb-0"},[_vm._v("\n              "+_vm._s(b.doc_no)+"\n            "),_c('br'),_vm._v(_vm._s(b.ar_code || '-')+": "+_vm._s(b.ar_name || '-')+"\n            ")]),_vm._v(" "),_c('td',{staticClass:"text-center pb-0"},[_vm._v("\n              "+_vm._s(_vm.dateFormatDMY(b.doc_date))),_c('br'),_vm._v("\n              "+_vm._s(_vm.dateTimeHHMMSS(b.create_time))+"\n            ")]),_vm._v(" "),_c('td',[_vm._v("\n              "+_vm._s(b.description)+"\n            ")]),_vm._v(" "),_c('td',{staticClass:"text-right pb-0"},[_vm._v("\n              "+_vm._s(_vm.numberFormatDecimal(b.total_amount ))+"\n            ")]),_vm._v(" "),_c('td',{staticClass:"text-center pb-0"},[_c('h4',[_c('span',{directives:[{name:"show",rawName:"v-show",value:(b.bill_type == 0 && b.cash_amount > 0),expression:"b.bill_type == 0 && b.cash_amount > 0"}],staticClass:"badge badge-success"},[_vm._v("เงินสด")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(b.bill_type == 0 && b.bank_amount > 0),expression:"b.bill_type == 0 && b.bank_amount > 0"}],staticClass:"badge badge-info"},[_vm._v("เงินโอน")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(b.bill_type == 1),expression:"b.bill_type == 1"}],staticClass:"badge badge-warning"},[_vm._v("เงินเชื่อ")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(b.holding_status == 1 && b.bank_amount == 0 && b.cash_amount == 0),expression:"b.holding_status == 1 && b.bank_amount == 0 && b.cash_amount == 0"}],staticClass:"badge badge-danger"},[_vm._v("พักบิล")])])]),_vm._v(" "),_c('td',{staticClass:"text-center pb-0"},[_c('button',{staticClass:"btn btn-info pt-0 pb-0",staticStyle:{"font-size":"20px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.printPDF(b)}}},[_c('i',{staticClass:"fas fa-file-pdf"})])])])}),_vm._v(" "),(_vm.paginate.length < 1)?_c('tr',[_c('th',{staticClass:"text-center",attrs:{"scope":"row","colspan":"9"}},[_vm._v("ไม่มีข้อมูล")])]):_vm._e()],2)])]),_vm._v(" "),(_vm.bill_data.length > _vm.items_perpage)?_c('div',{staticClass:"d-flex justify-content-end mb-3 mr-2",attrs:{"id":"components-pagination-demo-mini"}},[_c('a-pagination',{attrs:{"size":"large","total":_vm.bill_data.length,"itemRender":_vm.itemRender},on:{"change":_vm.onChange},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1):_vm._e()]),_vm._v(" "),_c('form',{ref:"printHolding",attrs:{"action":"/static/pdf/sale_bill.php","target":"_blank","method":"POST"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form_data),expression:"form_data"}],attrs:{"type":"hidden","name":"data"},domProps:{"value":(_vm.form_data)},on:{"input":function($event){if($event.target.composing){ return; }_vm.form_data=$event.target.value}}})])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title",attrs:{"id":"PaymentModalCashTitle"}},[_vm._v("รายการบิลขายทั้งหมด")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-3 text-right pt-1"},[_c('h3',[_vm._v("ค้นหา")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-dark"},[_c('tr',{staticClass:"text-center"},[_c('th',{attrs:{"scope":"col"}},[_vm._v("#")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("เลขที่บิล/ลูกค้า")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("วันที่")]),_vm._v(" "),_c('th',{staticStyle:{"width":"20%"},attrs:{"scope":"col"}},[_vm._v("หมายเหตุ")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("ราคารวม")]),_vm._v(" "),_c('th',{staticStyle:{"width":"10%"},attrs:{"scope":"col"}},[_vm._v("ประเภทบิล")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("พิมพ์บิล")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/27.5734d03cec2ea9850668.js